<template>
  <div class="home">
    <HomePlacard></HomePlacard>
    <TalkingPoints id="about"></TalkingPoints>
    <DonateBox></DonateBox>
    <QuotePhil id="quote"></QuotePhil>
    <ExtraInfo></ExtraInfo>
    <AdditInfo id="additInfo"></AdditInfo>
    <FooterBar></FooterBar>
  </div>

</template>
<style lang="scss">
a {
  font-weight: bold;
  color: rgb(79, 121, 168);
}
</style>
<script>
import HomePlacard from '../components/HomePlacard';
import TalkingPoints from '../components/TalkingPoints';
import DonateBox from '../components/DonateBox';
import QuotePhil from '../components/QuotePhil';
import ExtraInfo from '../components/ExtraInfo';
import AdditInfo from '../components/AdditInfo';
import FooterBar from '../components/FooterBar';
// @ is an alias to /src

export default {
  name: 'HomeView',
  components:{
    HomePlacard,
    TalkingPoints,
    DonateBox,
    QuotePhil,
    ExtraInfo,
    AdditInfo,
    FooterBar,
  }
}
</script>
